export default "__VITE_ASSET__CIzL9T3R__"